import styled from "styled-components";

export const FooterSection = styled.footer`
    text-align: center;
    padding: 10px 0;
    `

    export const FooterDesc = styled.p`
    color: #888
`
